// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"9992791b","966":"f42d49a1"}[chunkId] + ".chunk.js";
};